<template>
    <div class="login">
        <van-nav-bar title="会员登录" left-arrow @click-left="$router.go(-1)" />
        <div class="container">
            <div class="title">
                <h3>手机号登录</h3>
                <p>未注册的手机号登录后将自动注册</p>
            </div>

            <div class="form">
                <div class="form-item">
                    <input v-model="mobile" class="inp" maxlength="11" placeholder="请输入手机号码" type="text">
                </div>
                <div class="form-item">
                    <input v-model="picCode" class="inp" maxlength="5" placeholder="请输入图形验证码" type="text">
                    <img v-if="picUrl" :src="picUrl" alt="验证码" @click="getpicCode">
                </div>
                <div class="form-item">
                    <input v-model="phoneCode" class="inp" placeholder="请输入短信验证码" type="text">
                    <button @click="getcode">{{ second === totalSecond ? "获取验证码" : second + '秒后获取验证码' }}</button>
                </div>
            </div>

            <div @click="userLogin" class="login-btn">登录</div>
        </div>
    </div>
</template>

<script>
import { getPicCode, getMsgCode, codeLogin } from "@/api/login.js"
import { Toast } from "vant"
import { mapMutations } from "vuex"
export default {
    data() {
        return {
            mobile: "18917286702",  //用户输入的手机号
            picCode: '',  //用户输入的图像验证码
            picKey: '',   //图形验证码的key值
            picUrl: '',   //图片
            phoneCode: "",//手机验证码

            // 倒计时相关-----------------------------
            totalSecond: 5, //总的秒数
            second: 5,//当前的秒数
            timer: null//定时器id
        }
    },
    name: "LoginIndex",
    async created() {
        this.getpicCode()
    },
    methods: {

        ...mapMutations("user", ["setUserInfo"]),

        // 获取图形验证码
        async getpicCode() {
            const { data: { base64, key } } = await getPicCode()
            this.picUrl = base64,
                this.picKey = key,
                Toast("验证码请求成功")
        },
        // 获取手机号验证码
        async getcode() {

            if (this.validFn()) {
                // 如果当前没有定时器 并且总秒数等于当前的秒数的时候再开启定时器
                if (!this.timer && this.second === this.totalSecond) {

                    let { message } = await getMsgCode(this.picCode, this.picKey, this.mobile)
                    Toast(message)
                    if (message === '^_^小智提示: 测试环境验证码为: 246810') {
                        this.phoneCode = "246810"
                    }
                    this.timer = setInterval(() => {
                        this.second--
                        if (this.second <= 0) {
                            clearInterval(this.timer)
                            this.second = this.totalSecond
                            this.timer = null
                        }
                    }, 1000);
                }
            }
        },

        // 校验图形验证码
        // 校验输入框内容
        validFn() {

            if (!this.mobilef) {
                if (!/^1[3-9]\d{9}$/.test(this.mobile)) {
                    Toast('请输入正确的手机号')
                    return false
                }
            } else {
                Toast("请先输入手机号")
            }

            if (!/^\w{4}$/.test(this.picCode)) {
                Toast('请输入正确的图形验证码')
                return false
            }
            return true
        },

        async userLogin() {
            if (!this.validFn()) {
                return
            }

            if (!/^\d{6}$/.test(this.phoneCode)) {
                Toast("请输入正确的手机验证码")
                return
            }

            let { data } = await codeLogin(this.mobile, this.phoneCode)
            console.log(data);

            this.setUserInfo(data)
            Toast("登录成功")



            if(this.$route.query.backUrl){
                this.$router.push(this.$route.query.backUrl)
            }else{
                 this.$router.push('/')

            }
           
        }

    },

    destroyed() {
        clearInterval(this.timer)
    }
}
</script>

<style lang="less" scoped>
.container {
    padding: 49px 29px;

    .title {
        margin-bottom: 20px;

        h3 {
            font-size: 26px;
            font-weight: normal;
        }

        p {
            line-height: 40px;
            font-size: 14px;
            color: #b8b8b8;
        }
    }

    .form-item {
        border-bottom: 1px solid #f3f1f2;
        padding: 8px;
        margin-bottom: 14px;
        display: flex;
        align-items: center;

        .inp {
            display: block;
            border: none;
            outline: none;
            height: 32px;
            font-size: 14px;
            flex: 1;
        }

        img {
            width: 94px;
            height: 31px;
        }

        button {
            height: 31px;
            border: none;
            font-size: 13px;
            color: #cea26a;
            background-color: transparent;
            padding-right: 9px;
        }
    }

    .login-btn {
        width: 100%;
        height: 42px;
        margin-top: 39px;
        background: linear-gradient(90deg, #ecb53c, #ff9211);
        color: #fff;
        border-radius: 39px;
        box-shadow: 0 10px 20px 0 rgba(0, 0, 0, .1);
        letter-spacing: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>